import React, { PropsWithChildren } from 'react';
import styles from './OutlineTitlePanel.module.scss';

type OutlineTitlePanelOwnProps = {
  className?: string;
  titleClassName?: string;
  title?: string;
};

type OutlineTitlePanelProps = PropsWithChildren<OutlineTitlePanelOwnProps>;
const OutlineTitlePanel: React.FC<OutlineTitlePanelProps> = ({
  className = '',
  titleClassName = '',
  title,
  children,
}) => {
  const baseCls = `${styles.OutlineTitlePanelContainer} ${className}`.trim();
  const titleCls = `${styles.TitleContainer} ${titleClassName}`.trim();

  return (
    <div className={baseCls}>
      <span className={titleCls}>{title}</span>
      {children}
    </div>
  );
};

export default OutlineTitlePanel;
